<template>
  <div class="payBox vux-1px-b">
    <div class="bkTit">
      精品课推荐
    </div>
    <div class="allBox" @click="jumpPay">
      <img :src="courseObj.coverPicUrl" />
      <div class="wordBox">
        <span class="title">{{ courseObj.courseName }}</span>
        <div class="infoBox">
          <span>{{ courseObj.clickCount }}位同仁有意向</span>
          <span>￥{{ (courseObj.price / 100).toFixed(2) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    courseObj: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    jumpPay() {
      this.$sa.setSaSession_href(
        this.$route,
        `/html/ess.html#/courseDetail?courseId=${this.courseObj.id}&type=ess`
      );
    }
  },
  computed: {},
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.payBox {
  margin-top: 0.43rem;
  padding-bottom: 0.43rem;
  .bkTit {
    font-size: 0.43rem;
    color: #161616;
    margin-bottom: 0.32rem;
    line-height: 0.4rem;
    font-weight: bold;
  }
  .allBox {
    display: flex;
    align-items: center;
    .wordBox {
      width: 100%;
      height: 1.87rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    img {
      width: 3.31rem;
      height: 1.87rem;
      border-radius: 0.13rem;
      margin-right: 0.27rem;
    }
    .title {
      font-size: 0.4rem;
      color: #161616;
      line-height: 0.56rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .infoBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span:first-of-type {
        font-size: 0.32rem;
        color: #666666;
        line-height: 0.32rem;
      }
      span:last-of-type {
        color: #027cfa;
        font-size: 0.45rem;
        line-height: 0.45rem;
      }
    }
  }
}
</style>
